import { render, staticRenderFns } from "./BgUploader.vue?vue&type=template&id=65c3c6a6&scoped=true"
import script from "./BgUploader.vue?vue&type=script&lang=js"
export * from "./BgUploader.vue?vue&type=script&lang=js"
import style0 from "./BgUploader.vue?vue&type=style&index=0&id=65c3c6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3c6a6",
  null
  
)

export default component.exports